<div *ngIf="reportType === 'Monthwise'">
  <div id="print-section" style="font-family: Arial; margin: 10mm; border: 1px solid black;">

    <!-- HEADER -->
    <table style="width: 100%; border-collapse: collapse; border-bottom: 1px solid black;">
     <tr>
        <td style="font-size: 18px; font-weight: bold; text-align:center; white-space: nowrap; padding: 8px;">
          हिंदुस्तान प्रकाशन संस्था 
        </td>
        <td style="font-size: 20px; font-weight: bold; text-align: center;">
          Book Credit Note Report
        </td>
        <td style="font-size: 18px; text-align: right; white-space: nowrap; padding: 8px;">
          दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
        </td>
      </tr>

      <tr style="border-top: 1px solid black;">
        <td style="padding: 8px;font-weight: bold;font-size: 18px;text-align: center;">विवेक पुस्तक प्रकाशन</td>
        <td style="font-size: 18px; font-weight: bold; text-align: center; padding: 8px;">
          Monthwise
        </td>
        <td style="font-size: 16px; text-align: right; white-space: nowrap; padding: 8px;">
          Date : From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
        </td>
      </tr>
    </table>

    <!-- TABLE -->
    <table style="width:100%; border-collapse: collapse; border: 1px solid black; text-align:right;">
      <thead>
        <tr style="background-color:#dfe6e9;">
          <th style="padding:6px; border:1px solid black; text-align:left;">Office Representative</th>
          <th *ngFor="let month of monthList" style="padding:1px; border:1px solid black;">
            {{ month }}
          </th>
          <th style="padding:6px; border:1px solid black;">Total</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let row of monthwiseData">
          <td style="padding:6px; border:1px solid black; text-align:left;">
            {{ row.office_rep_name }}
          </td>

          <td *ngFor="let month of monthList" style="padding:6px; border:1px solid black;">
            {{ (row[month] || 0)  }}
          </td>

          <td style="padding:6px; border:1px solid black; font-weight:bold;">
            {{ (row.Total || 0) }}
          </td>
        </tr>
      </tbody>

      <tfoot>
        <tr style="font-weight:bold; background-color: #c8753f;">
          <td style="padding:6px; border:1px solid black; text-align:left;">Total</td>

          <td *ngFor="let month of monthList" style="padding:6px; border:1px solid black;">
            {{ (monthTotals[month] || 0)  }}
          </td>

          <td style="padding:6px; border:1px solid black;">
            {{ (overallTotal || 0)  }}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>

  <!-- BUTTONS -->
  <div class="noPrint" style="text-align:right; margin:10px;">
    <button (click)="printPage4()" style="padding:6px 12px; background:#4caf50; color:white; border:none; border-radius:6px;">
      🖨️ Print
    </button>

    <button (click)="exportExcel()" style="padding:6px 12px; background:#2196f3; color:white; border:none; border-radius:6px;">
      ⬇️ Excel
    </button>
     <button class="btn btn-secondary" mat-dialog-close>Close</button>
  </div>
</div>
